module.exports = __webpack_public_path__ + "files/5f330280d94cd229355974862ea7d652.svg";